import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { cva } from 'class-variance-authority';
import { cn } from 'Utils/cn';

export const badgeVariants = cva(
    'inline-flex items-center justify-center font-medium whitespace-nowrap rounded-full align-middle',
    {
        variants: {
            color: {
                black: 'bg-[#919191]/15 text-[#919191]',
                success: 'bg-[#26b02a]/15 text-[#26b02a]',
                danger: 'bg-[#d15554]/15 text-[#d15554]',
                warning: 'bg-[#ffc107]/15 text-[#ffb149]',
            },
            size: {
                medium: 'text-xs px-1.5 leading-[20px]',
                small: 'text-2xs px-1.5 leading-[18px]',
            },
        },
        defaultVariants: {
            color: 'black',
            size: 'medium',
        },
    },
);

const Badge = forwardRef(function Badge(props, ref) {
    const { className, children, color, size, ...htmlProps } = props;

    return (
        <span ref={ref} className={cn(badgeVariants({ color, size }), className)} {...htmlProps}>
            {children}
        </span>
    );
});

export default Badge;

Badge.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    color: PropTypes.oneOf(['success', 'danger', 'black', 'warning']),
    size: PropTypes.oneOf(['small', 'medium']),
};
